/**
 * @generated SignedSource<<db8273acd1d4ef3dacb57c643370f50f>>
 * @relayHash 1dc50fe8d758b61da5a5e840e523333a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b51fa287b9139b89aee217cf2f6f3456d113b93964090c0346cbb9bc035b70fd

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterMediaConfigOperationType = "BANNER_UPLOAD" | "LOGO_UPLOAD" | "READ" | "%future added value";
export type hubHomeContentWrapperQuery$variables = {
  cloudId: string;
  hubAri: string;
  hubEditMode: boolean;
  includeLayoutTranslations?: boolean | null;
  includeTranslatableBlocksSchema?: boolean | null;
  isConfigurableSiteTreeEnabled?: boolean | null;
  isDraft?: boolean | null;
  isPortalPage?: boolean | null;
  operationType?: HelpCenterMediaConfigOperationType | null;
  pageAri: string;
  rovoConfigFromKosh?: boolean | null;
};
export type hubHomeContentWrapperQuery$data = {
  readonly helpCenter: {
    readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference" | "hubHomeContent_AtlassianHubHome_HubInfo">;
  } | null;
  readonly me: {
    readonly user: {
      readonly accountId: string;
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference">;
};
export type hubHomeContentWrapperQuery = {
  response: hubHomeContentWrapperQuery$data;
  variables: hubHomeContentWrapperQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubEditMode"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeLayoutTranslations"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeTranslatableBlocksSchema"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isConfigurableSiteTreeEnabled"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isDraft"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPortalPage"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "operationType"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageAri"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "rovoConfigFromKosh"
},
v11 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v12 = {
  "kind": "Variable",
  "name": "isDraft",
  "variableName": "isDraft"
},
v13 = {
  "kind": "Variable",
  "name": "pageAri",
  "variableName": "pageAri"
},
v14 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v15 = {
  "kind": "Variable",
  "name": "operationType",
  "variableName": "operationType"
},
v16 = [
  {
    "kind": "ScalarField",
    "name": "asapIssuer"
  },
  {
    "kind": "ScalarField",
    "name": "mediaCollectionName"
  },
  {
    "kind": "ScalarField",
    "name": "mediaToken"
  },
  {
    "kind": "ScalarField",
    "name": "mediaUrl"
  }
],
v17 = {
  "kind": "Variable",
  "name": "helpCenterAri",
  "variableName": "hubAri"
},
v18 = {
  "kind": "ScalarField",
  "name": "locale"
},
v19 = {
  "kind": "ScalarField",
  "name": "extensionType"
},
v20 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v21 = {
  "kind": "ScalarField",
  "name": "id"
},
v22 = {
  "kind": "ScalarField",
  "name": "isPublished"
},
v23 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v24 = {
  "concreteType": "HelpCenterPageName",
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": (v23/*: any*/)
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    (v22/*: any*/),
    (v24/*: any*/)
  ],
  "type": "HelpCenterPage"
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v27 = {
  "kind": "ScalarField",
  "name": "type"
},
v28 = {
  "kind": "ScalarField",
  "name": "cornerRadius"
},
v29 = {
  "concreteType": "HelpCenterNavigationBar",
  "kind": "LinkedField",
  "name": "navigationBar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "backgroundColor"
    },
    {
      "kind": "ScalarField",
      "name": "borderColor"
    },
    {
      "kind": "ScalarField",
      "name": "borderType"
    },
    (v28/*: any*/),
    {
      "kind": "ScalarField",
      "name": "padding"
    },
    {
      "kind": "ScalarField",
      "name": "positionType"
    },
    {
      "kind": "ScalarField",
      "name": "textColor"
    }
  ]
},
v30 = [
  (v21/*: any*/),
  (v24/*: any*/),
  {
    "concreteType": "HelpCenterPageDescription",
    "kind": "LinkedField",
    "name": "description",
    "plural": false,
    "selections": (v23/*: any*/)
  },
  {
    "condition": "isDraft",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      (v22/*: any*/)
    ]
  }
],
v31 = [
  (v18/*: any*/),
  {
    "kind": "ScalarField",
    "name": "localeDisplayName"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "name": "hubHomeContentWrapperQuery",
    "selections": [
      {
        "args": (v11/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "hubAri",
                "variableName": "hubAri"
              },
              {
                "kind": "Variable",
                "name": "includeLayoutTranslations",
                "variableName": "includeLayoutTranslations"
              },
              {
                "kind": "Variable",
                "name": "includeTranslatableBlocksSchema",
                "variableName": "includeTranslatableBlocksSchema"
              },
              {
                "kind": "Variable",
                "name": "isConfigurableSiteTreeEnabled",
                "variableName": "isConfigurableSiteTreeEnabled"
              },
              (v12/*: any*/),
              {
                "kind": "Variable",
                "name": "isPortalPage",
                "variableName": "isPortalPage"
              },
              (v13/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "hubHomeContent_AtlassianHubHome_HubInfo"
          },
          {
            "args": [
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
      },
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v14/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v10/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "hubHomeContentWrapperQuery",
    "selections": [
      {
        "args": (v11/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "alias": "pageMediaConfig",
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "pageAri"
              },
              (v12/*: any*/),
              (v15/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v16/*: any*/)
          },
          {
            "condition": "includeLayoutTranslations",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v17/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "parentAri",
                    "variableName": "pageAri"
                  }
                ],
                "concreteType": "HelpCenterHubLayoutTranslations",
                "kind": "LinkedField",
                "name": "layoutTranslations",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  {
                    "concreteType": "HelpCenterHubTranslationBlock",
                    "kind": "LinkedField",
                    "name": "blocks",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "localId"
                      },
                      (v19/*: any*/),
                      {
                        "concreteType": "HelpCenterHubTranslationField",
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fieldPath"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "value"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": [
              (v17/*: any*/),
              (v12/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isHelpCenterQueryResult"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "condition": "isConfigurableSiteTreeEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "HelpCenterSiteTree",
                        "kind": "LinkedField",
                        "name": "siteTree",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "HelpCenterFolder",
                            "kind": "LinkedField",
                            "name": "root",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "concreteType": "HelpCenterSiteTreeNodeConnection",
                                "kind": "LinkedField",
                                "name": "contents",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                      (v20/*: any*/),
                                      (v25/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "concreteType": "HelpCenterFolderName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": (v23/*: any*/)
                                          },
                                          {
                                            "concreteType": "HelpCenterSiteTreeNodeConnection",
                                            "kind": "LinkedField",
                                            "name": "contents",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "nodes",
                                                "plural": true,
                                                "selections": [
                                                  (v20/*: any*/),
                                                  (v25/*: any*/),
                                                  (v26/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "HelpCenterFolder"
                                      },
                                      (v26/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasUnpublishedChanges"
                  },
                  (v27/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "hoistedProjectKey"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "slug"
                  },
                  {
                    "concreteType": "HelpCenterName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": (v23/*: any*/)
                  },
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/)
                    ]
                  },
                  {
                    "alias": "allPages",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "ids": []
                        }
                      }
                    ],
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": (v30/*: any*/),
                    "storageKey": "pages(filter:{\"ids\":[]})"
                  },
                  {
                    "alias": "customPages",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "ids": [],
                          "type": "CUSTOM"
                        }
                      }
                    ],
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": (v30/*: any*/),
                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                  },
                  {
                    "condition": "includeTranslatableBlocksSchema",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "homePage",
                        "args": [
                          {
                            "fields": [
                              {
                                "items": [
                                  {
                                    "kind": "Variable",
                                    "name": "ids.0",
                                    "variableName": "hubAri"
                                  }
                                ],
                                "kind": "ListValue",
                                "name": "ids"
                              },
                              {
                                "kind": "Literal",
                                "name": "type",
                                "value": "CUSTOM_HOME"
                              }
                            ],
                            "kind": "ObjectValue",
                            "name": "filter"
                          }
                        ],
                        "concreteType": "HelpCenterPage",
                        "kind": "LinkedField",
                        "name": "pages",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "pageType"
                          },
                          {
                            "concreteType": "HelpCenterPageLayout",
                            "kind": "LinkedField",
                            "name": "pageLayout",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "HelpCenterLayoutAdf",
                                "kind": "LinkedField",
                                "name": "layoutAdf",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "HelpCenterTranslatableBlock",
                                    "kind": "LinkedField",
                                    "name": "translatableBlocksSchema",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "blockType"
                                      },
                                      (v19/*: any*/),
                                      {
                                        "concreteType": "HelpCenterTranslatableField",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "path"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "kind"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "arrayKey"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "idField"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v21/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "includeLayoutTranslations",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "siteDefaultLanguageTag"
                      }
                    ]
                  },
                  {
                    "condition": "isPortalPage",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "condition": "includeLayoutTranslations",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "HelpCenterAnnouncements",
                            "kind": "LinkedField",
                            "name": "announcements",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "HelpCenterAnnouncement",
                                "kind": "LinkedField",
                                "name": "homePageAnnouncements",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "HelpCenterTranslation",
                                    "kind": "LinkedField",
                                    "name": "nameTranslationsRaw",
                                    "plural": true,
                                    "selections": (v31/*: any*/)
                                  },
                                  {
                                    "concreteType": "HelpCenterTranslation",
                                    "kind": "LinkedField",
                                    "name": "descriptionTranslationsRaw",
                                    "plural": true,
                                    "selections": (v31/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v27/*: any*/),
                  {
                    "alias": "currentPage",
                    "args": [
                      {
                        "fields": [
                          {
                            "items": [
                              {
                                "kind": "Variable",
                                "name": "ids.0",
                                "variableName": "pageAri"
                              }
                            ],
                            "kind": "ListValue",
                            "name": "ids"
                          },
                          {
                            "kind": "Variable",
                            "name": "isEditMode",
                            "variableName": "hubEditMode"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "filter"
                      }
                    ],
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v21/*: any*/),
                      (v24/*: any*/),
                      {
                        "condition": "rovoConfigFromKosh",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "HelpCenterPageRovoConfig",
                            "kind": "LinkedField",
                            "name": "rovoConfig",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isCustomAgentsAvailable"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isRovoEnabled"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "agentId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "widgetContainerAri"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterPageLayout",
                        "kind": "LinkedField",
                        "name": "pageLayout",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "HelpCenterLayoutAdf",
                            "kind": "LinkedField",
                            "name": "layoutAdf",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "HelpCenterLayoutAdfContentConnection",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "HelpCenterLayoutAdfContentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "HelpCenterLayoutAdfContent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "content"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "secondaryColor"
                          }
                        ]
                      },
                      (v29/*: any*/),
                      {
                        "concreteType": "HelpCenterBrandingTypography",
                        "kind": "LinkedField",
                        "name": "typography",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "headingFont"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "bodyFont"
                          }
                        ]
                      },
                      (v28/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "spaceDensity"
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              },
              (v26/*: any*/)
            ]
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "hubAri"
              },
              (v12/*: any*/),
              (v15/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v16/*: any*/)
          }
        ]
      },
      {
        "condition": "hubEditMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                  }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
              }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "cloudUrl"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v14/*: any*/),
              (v21/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b51fa287b9139b89aee217cf2f6f3456d113b93964090c0346cbb9bc035b70fd",
    "metadata": {},
    "name": "hubHomeContentWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "65c638a34125a0b8b668a614693bd76d";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
